import React from "react";
import { errorRedirect } from "../utils/errorRedirect";

const InternalError: React.FC = () => {
  const handleReportClick = () => {
    const emailAddress = "vtu7410@gmail.com";
    window.location.href = `mailto:${emailAddress}?`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center font-poppins">
      <div className="text-center">
        <h1 className="text-[200px] font-bold text-blue">500</h1>
        <h2 className="text-gray-700 font-bold text-2xl">
          Internal Server Error
        </h2>
        <div className="flex flex-col gap-5">
          <p className="text-gray-700 mt-4">
            The server encountered an internal error or misconfiguration and was
            unable to complete your request!
          </p>
          <p>
            If the problem persists, please{" "}
            <a onClick={handleReportClick} className="text-blue-500 underline">
              report
            </a>{" "}
            your problem.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InternalError;
